// Kept in the backend's order (`_CRM_ENTITY_KEYS` in self_importer): the first
// selected entity is the one the draft job is created with on upload, before
// `crm-config` replaces it with the whole selection.
// `owners` is a valid IMPORT_ENTITIES value but is not a CRM bundle entity —
// the CRM flow never offers it as a selectable instance.
export const CRM_ENTITIES = ['properties', 'developments', 'contacts'];

export const emptyCrmInstances = () =>
  CRM_ENTITIES.reduce((instances, entity) => {
    instances[entity] = false;
    return instances;
  }, {});

export const selectedCrmEntities = (instances) =>
  CRM_ENTITIES.filter((entity) => Boolean(instances?.[entity]));

export const hasSelectedCrmEntities = (instances) =>
  selectedCrmEntities(instances).length > 0;

export const primaryCrmEntity = (instances) =>
  selectedCrmEntities(instances)[0] ?? null;

export const buildCrmInstancesPayload = (instances) =>
  CRM_ENTITIES.reduce((payload, entity) => {
    payload[entity] = Boolean(instances?.[entity]);
    return payload;
  }, {});
